import { Link } from 'react-router-dom'

export function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4 text-center">
      <h1 className="text-4xl font-bold text-foreground">404</h1>
      <p className="mt-2 text-sm text-muted-foreground">Esta página não existe.</p>
      <Link
        to="/"
        className="mt-6 rounded-2xl bg-primary px-6 py-2 text-sm font-semibold text-primary-foreground hover:bg-primary/90"
      >
        Voltar para o início
      </Link>
    </div>
  )
}
